import { NetworkType } from '../../enums';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedNetwork = {
    id: 0,
    name: 'Mocked Network Name',
    logo: 'https://network.logo',
    description: 'Mocked Network Description',
    networkContact: {
        fullName: 'nw-fullName',
        email: 'nw-email',
        telephoneNumber: 'nw-telephoneNumber'
    },
    weenatContact: {
        fullName: 'wee-fullName',
        email: 'wee-email',
        telephoneNumber: 'wee-telephoneNumber'
    },
    /** An approximative integer count of the network devices */
    deviceCount: 3,
    deviceLocations: {
        type: 'Polygon',
        coordinates: [[[1, 1]]]
    },
    distanceToTarget: 3,
    type: NetworkType.community,
    adherentFarmsCount: 7
};
export const mockedGetManyNetworks = mockedPaginatedResponse([
    {
        ...mockedNetwork
    }
]);
const mock = {
    get: mockedRequester(mockedNetwork, 'networks.get'),
    getMany: mockedRequester(mockedGetManyNetworks, 'networks.getMany')
};
export default mock;
